/*
 * CQA & CPPs Summary — demo dataset
 * ---------------------------------------------------------------------------
 * AUTO-GENERATED from CQA_Summary_Table.xlsx (do not hand-edit).
 * Process-stage / attribute rows with per-batch operational values.
 * Excel serial date/time values were converted to human-readable strings and
 * fractional viabilities to percentages at generation time.
 *   columns : source batch columns present in the workbook
 *   gmp     : GMP run label per batch (shown in the column header)
 *   rows    : [{ stage, attribute, values: { <batch>: "<formatted>" } }]
 *             (a blank stage continues the previous process stage — grouped in UI)
 */

export const CQA_SUMMARY = {
  "columns": [
    "2388-OXB-A-1",
    "2785-OXB-B-1"
  ],
  "gmp": {
    "2388-OXB-A-1": "GMP#2",
    "2785-OXB-B-1": "GMP#3"
  },
  "rows": [
    {
      "stage": "Thawed cell vial",
      "attribute": "Viable cell concentration",
      "values": {
        "2388-OXB-A-1": "262,000",
        "2785-OXB-B-1": "251,000"
      }
    },
    {
      "stage": "",
      "attribute": "Viability (%)",
      "values": {
        "2388-OXB-A-1": "94.5%",
        "2785-OXB-B-1": "97.4%"
      }
    },
    {
      "stage": "",
      "attribute": "Time flask placed in the incubator",
      "values": {
        "2388-OXB-A-1": "10:27",
        "2785-OXB-B-1": "26-SEP-2025 10:21"
      }
    },
    {
      "stage": "CSP0",
      "attribute": "Incubation duration",
      "values": {
        "2388-OXB-A-1": "73h56min",
        "2785-OXB-B-1": "73h38min"
      }
    },
    {
      "stage": "",
      "attribute": "Viable cell concentration",
      "values": {
        "2388-OXB-A-1": "1,310,000",
        "2785-OXB-B-1": "1,440,000"
      }
    },
    {
      "stage": "",
      "attribute": "Viability (%)",
      "values": {
        "2388-OXB-A-1": "91%",
        "2785-OXB-B-1": "93.3%"
      }
    },
    {
      "stage": "CSP1",
      "attribute": "Incubation duration",
      "values": {
        "2388-OXB-A-1": "96h 42min",
        "2785-OXB-B-1": "97h42min"
      }
    },
    {
      "stage": "",
      "attribute": "Viability (%)",
      "values": {
        "2388-OXB-A-1": "97.8%",
        "2785-OXB-B-1": "95.9%"
      }
    },
    {
      "stage": "",
      "attribute": "Viable cell concentration",
      "values": {
        "2388-OXB-A-1": "3,080,000",
        "2785-OXB-B-1": "2,650,000"
      }
    },
    {
      "stage": "CSP2",
      "attribute": "Incubation duration",
      "values": {
        "2388-OXB-A-1": "94h04mins",
        "2785-OXB-B-1": "92h43min"
      }
    },
    {
      "stage": "",
      "attribute": "Viability (%)",
      "values": {
        "2388-OXB-A-1": "92.7%",
        "2785-OXB-B-1": "94.1%"
      }
    },
    {
      "stage": "",
      "attribute": "Viable cell concentration",
      "values": {
        "2388-OXB-A-1": "4,170,000",
        "2785-OXB-B-1": "3,860,000"
      }
    },
    {
      "stage": "CSP3",
      "attribute": "Incubation duration",
      "values": {
        "2388-OXB-A-1": "72h44mins",
        "2785-OXB-B-1": "73h 19min\n 73h23min\n 73h29min"
      }
    },
    {
      "stage": "",
      "attribute": "Viability (%)",
      "values": {
        "2388-OXB-A-1": "98.1%",
        "2785-OXB-B-1": "96.8%"
      }
    },
    {
      "stage": "",
      "attribute": "Viable cell concentration",
      "values": {
        "2388-OXB-A-1": "2,480,000",
        "2785-OXB-B-1": "2,830,000"
      }
    },
    {
      "stage": "Passage 4",
      "attribute": "P4 Post Inoculation Seeding Density",
      "values": {
        "2388-OXB-A-1": "322,000",
        "2785-OXB-B-1": "310,000"
      }
    },
    {
      "stage": "",
      "attribute": "P4 Post Inoculation Viability",
      "values": {
        "2388-OXB-A-1": "97.9%",
        "2785-OXB-B-1": "98.7%"
      }
    },
    {
      "stage": "50L DAY 1",
      "attribute": "Viable cell concentration",
      "values": {
        "2388-OXB-A-1": "673,000",
        "2785-OXB-B-1": "644,000"
      }
    },
    {
      "stage": "",
      "attribute": "Viability",
      "values": {
        "2388-OXB-A-1": "99.1%",
        "2785-OXB-B-1": "98.5%"
      }
    },
    {
      "stage": "50L DAY 2",
      "attribute": "Viable cell concentration",
      "values": {
        "2388-OXB-A-1": "1,600,000",
        "2785-OXB-B-1": "1,530,000"
      }
    },
    {
      "stage": "",
      "attribute": "Viability",
      "values": {
        "2388-OXB-A-1": "99.4%",
        "2785-OXB-B-1": "99%"
      }
    },
    {
      "stage": "CSP4",
      "attribute": "Incubation duration",
      "values": {
        "2388-OXB-A-1": "69h04min",
        "2785-OXB-B-1": "68h08min"
      }
    },
    {
      "stage": "",
      "attribute": "50L pre-harvest Viability",
      "values": {
        "2388-OXB-A-1": "99.1%",
        "2785-OXB-B-1": "96.3%"
      }
    },
    {
      "stage": "",
      "attribute": "50L pre-harvest Viable cell concentration",
      "values": {
        "2388-OXB-A-1": "3,900,000",
        "2785-OXB-B-1": "3,620,000"
      }
    },
    {
      "stage": "P5 Post-Inoculation",
      "attribute": "P5 Post Inoculation Seeding Density",
      "values": {
        "2388-OXB-A-1": "906,000",
        "2785-OXB-B-1": "923,000"
      }
    },
    {
      "stage": "",
      "attribute": "Viability",
      "values": {
        "2388-OXB-A-1": "98.8%",
        "2785-OXB-B-1": "98.5%"
      }
    },
    {
      "stage": "",
      "attribute": "End time and date of inoculation",
      "values": {
        "2388-OXB-A-1": "15:40",
        "2785-OXB-B-1": "15:51\n 13October2025"
      }
    },
    {
      "stage": "Perfusion A",
      "attribute": "Perfusion A start time/date",
      "values": {
        "2388-OXB-A-1": "13-MAY-2025 15:00",
        "2785-OXB-B-1": "14-OCT-2025 15:00"
      }
    },
    {
      "stage": "",
      "attribute": "Perfusion A end time/date",
      "values": {
        "2388-OXB-A-1": "14-MAY-2025 10:00",
        "2785-OXB-B-1": "15-OCT-2025 10:00"
      }
    },
    {
      "stage": "",
      "attribute": "Perfusion A duration",
      "values": {
        "2388-OXB-A-1": "19h00min",
        "2785-OXB-B-1": "19h00min"
      }
    },
    {
      "stage": "Pre-Transfection",
      "attribute": "Viable cell concentration",
      "values": {
        "2388-OXB-A-1": "3,850,000",
        "2785-OXB-B-1": "4,030,000"
      }
    },
    {
      "stage": "",
      "attribute": "Viability",
      "values": {
        "2388-OXB-A-1": "97.8%",
        "2785-OXB-B-1": "97.3%"
      }
    },
    {
      "stage": "",
      "attribute": "Pre-transfection offline pH; was adjustment required",
      "values": {
        "2388-OXB-A-1": "7.16 (No adjustment)",
        "2785-OXB-B-1": "7.20 (no adjustments)"
      }
    },
    {
      "stage": "Pre-Transfection (Tfx BMR)",
      "attribute": "Viable cell concentration",
      "values": {
        "2388-OXB-A-1": "4,620,000",
        "2785-OXB-B-1": "4,050,000"
      }
    },
    {
      "stage": "",
      "attribute": "Viability",
      "values": {
        "2388-OXB-A-1": "98.2%",
        "2785-OXB-B-1": "97.9%"
      }
    },
    {
      "stage": "Post-Transfection",
      "attribute": "Viable cell concentration",
      "values": {
        "2388-OXB-A-1": "3,730,000",
        "2785-OXB-B-1": "3,480,000"
      }
    },
    {
      "stage": "",
      "attribute": "Viability",
      "values": {
        "2388-OXB-A-1": "97.8%",
        "2785-OXB-B-1": "97.6%"
      }
    },
    {
      "stage": "",
      "attribute": "End time and date of Transfection mix addition",
      "values": {
        "2388-OXB-A-1": "14-MAY-2025 15:27",
        "2785-OXB-B-1": "15-OCT-2025 14:42"
      }
    },
    {
      "stage": "",
      "attribute": "Post transfection offline pH; was adjustment required",
      "values": {
        "2388-OXB-A-1": "7.12 (no adjustment)",
        "2785-OXB-B-1": "7.11 (no adjustments)"
      }
    },
    {
      "stage": "",
      "attribute": "Time between inoculation and end time of Transfection",
      "values": {
        "2388-OXB-A-1": "48 hours 11 min",
        "2785-OXB-B-1": "46h51min"
      }
    },
    {
      "stage": "PICS",
      "attribute": "Offline pH value; was adjustment required",
      "values": {
        "2388-OXB-A-1": "7.14 (no adjustment)",
        "2785-OXB-B-1": "7.09 (no adjustment)"
      }
    },
    {
      "stage": "",
      "attribute": "Viable cell concentration",
      "values": {
        "2388-OXB-A-1": "4,600,000",
        "2785-OXB-B-1": "3,950,000"
      }
    },
    {
      "stage": "",
      "attribute": "Viability",
      "values": {
        "2388-OXB-A-1": "96.1%",
        "2785-OXB-B-1": "96.1%"
      }
    },
    {
      "stage": "",
      "attribute": "Duration from transfection to induction start",
      "values": {
        "2388-OXB-A-1": "18 hours",
        "2785-OXB-B-1": "18 hours"
      }
    },
    {
      "stage": "Perfusion B",
      "attribute": "Perfusion B start time/date",
      "values": {
        "2388-OXB-A-1": "15-MAY-2025 09:34",
        "2785-OXB-B-1": "16-OCT-2025 08:53"
      }
    },
    {
      "stage": "",
      "attribute": "Perfusion B end time/date",
      "values": {
        "2388-OXB-A-1": "15May20-2/17:34",
        "2785-OXB-B-1": "16-OCT-2025 16:53"
      }
    },
    {
      "stage": "",
      "attribute": "Perfusion B duration",
      "values": {
        "2388-OXB-A-1": "8 hours",
        "2785-OXB-B-1": "8 hours"
      }
    },
    {
      "stage": "Perfusion C",
      "attribute": "Perfusion C start time/date",
      "values": {
        "2388-OXB-A-1": "15-MAY-2025 17:46",
        "2785-OXB-B-1": "16-OCT-2025 21:19"
      }
    },
    {
      "stage": "",
      "attribute": "Perfusion C end time/date",
      "values": {
        "2388-OXB-A-1": "16-MAY-2025 09:46",
        "2785-OXB-B-1": "17-OCT-2025 12:40"
      }
    },
    {
      "stage": "",
      "attribute": "Perfusion C duration",
      "values": {
        "2388-OXB-A-1": "16 hours",
        "2785-OXB-B-1": "15h 21min"
      }
    },
    {
      "stage": "PHPB",
      "attribute": "Duration between Post-induction and harvest",
      "values": {
        "2388-OXB-A-1": "24 hours 33 min",
        "2785-OXB-B-1": "28h 19min"
      }
    },
    {
      "stage": "",
      "attribute": "Pre-Harvest offline pH; was adjustment required",
      "values": {
        "2388-OXB-A-1": "7.18",
        "2785-OXB-B-1": "7.12 (No adjustment)"
      }
    },
    {
      "stage": "",
      "attribute": "Viable cell concentration",
      "values": {
        "2388-OXB-A-1": "4,910,000",
        "2785-OXB-B-1": "6,460,000"
      }
    },
    {
      "stage": "",
      "attribute": "Viability",
      "values": {
        "2388-OXB-A-1": "89.8%",
        "2785-OXB-B-1": "88.9%"
      }
    },
    {
      "stage": "Rapid Harvest",
      "attribute": "Start time/date",
      "values": {
        "2388-OXB-A-1": "16-MAY-2025 10:05",
        "2785-OXB-B-1": "17-SEP-2025 13:06"
      }
    },
    {
      "stage": "",
      "attribute": "End time/date",
      "values": {
        "2388-OXB-A-1": "16-MAY-2025 10:51",
        "2785-OXB-B-1": "17-SEP-2025 13:52"
      }
    },
    {
      "stage": "",
      "attribute": "Total harvest weight post sampling",
      "values": {
        "2388-OXB-A-1": "395.05 kg",
        "2785-OXB-B-1": "374.25 Kg"
      }
    },
    {
      "stage": "CLHV",
      "attribute": "Any pressure issues?",
      "values": {
        "2388-OXB-A-1": "No",
        "2785-OXB-B-1": "No"
      }
    },
    {
      "stage": "",
      "attribute": "Clarified harvest appearance",
      "values": {
        "2388-OXB-A-1": "No particulates observed",
        "2785-OXB-B-1": "No particulates observed"
      }
    },
    {
      "stage": "",
      "attribute": "0.2 micron filter passed filter integrity test?",
      "values": {
        "2388-OXB-A-1": "Yes",
        "2785-OXB-B-1": "Yes"
      }
    },
    {
      "stage": "",
      "attribute": "Clarified Harvest Quantity",
      "values": {
        "2388-OXB-A-1": "435.1L",
        "2785-OXB-B-1": "415.2kg"
      }
    },
    {
      "stage": "IXPK",
      "attribute": "Anion exchange chromatography peak Quantity",
      "values": {
        "2388-OXB-A-1": "18338.5g",
        "2785-OXB-B-1": "18398.3g"
      }
    },
    {
      "stage": "",
      "attribute": "Recipe successfully executed?",
      "values": {
        "2388-OXB-A-1": "Yes",
        "2785-OXB-B-1": "Yes"
      }
    },
    {
      "stage": "",
      "attribute": "Eluate bag appearance",
      "values": {
        "2388-OXB-A-1": "No particulates observed",
        "2785-OXB-B-1": "No particulates observed"
      }
    },
    {
      "stage": "",
      "attribute": "Chromatogram",
      "values": {
        "2388-OXB-A-1": "see separate tab",
        "2785-OXB-B-1": "see separate tab"
      }
    },
    {
      "stage": "CXFT",
      "attribute": "CIEX flow-through weight",
      "values": {
        "2388-OXB-A-1": "440.1 kg",
        "2785-OXB-B-1": "419.7Kg"
      }
    },
    {
      "stage": "",
      "attribute": "Recipe successfully executed?",
      "values": {
        "2388-OXB-A-1": "Yes",
        "2785-OXB-B-1": "Yes"
      }
    },
    {
      "stage": "",
      "attribute": "Eluate bag appearance",
      "values": {
        "2388-OXB-A-1": "No particulates observed",
        "2785-OXB-B-1": "No particulates observed"
      }
    },
    {
      "stage": "",
      "attribute": "Chromatogram",
      "values": {
        "2388-OXB-A-1": "see separate tab",
        "2785-OXB-B-1": "see separate tab"
      }
    },
    {
      "stage": "UDFD",
      "attribute": "Target VC met?",
      "values": {
        "2388-OXB-A-1": "Yes",
        "2785-OXB-B-1": "Yes"
      }
    },
    {
      "stage": "",
      "attribute": "Target dialvolume wash met?",
      "values": {
        "2388-OXB-A-1": "Yes",
        "2785-OXB-B-1": "Yes"
      }
    },
    {
      "stage": "",
      "attribute": "Final vector substance volume",
      "values": {
        "2388-OXB-A-1": "6418.4g",
        "2785-OXB-B-1": "6235.5g"
      }
    },
    {
      "stage": "",
      "attribute": "Number of aliquots",
      "values": {
        "2388-OXB-A-1": "21",
        "2785-OXB-B-1": "20"
      }
    },
    {
      "stage": "",
      "attribute": "Time aliquots frozen down",
      "values": {
        "2388-OXB-A-1": "17-MAY-2025 04:56",
        "2785-OXB-B-1": "18-OCT-2025 02:49"
      }
    }
  ]
};

// Columns to render for the batches currently in scope. A batch that exists in
// the workbook shows its own values; any other batch reuses the first columns
// data ("similar data") so every product/batch selection renders a full table.
export const getCqaColumns = (batches) => {
  const cols = CQA_SUMMARY.columns;
  const list = (batches && batches.length) ? batches : cols;
  return list.map((batch) => {
    const srcKey = cols.indexOf(batch) >= 0 ? batch : cols[0];
    return { batch, srcKey, gmp: CQA_SUMMARY.gmp[srcKey] || "" };
  });
};

// Group consecutive rows under their process stage (blank stage = continuation)
// so the Process Stage column can span its attribute rows.
export const getCqaGroups = () => {
  const groups = [];
  CQA_SUMMARY.rows.forEach((r) => {
    if (r.stage && r.stage.trim()) groups.push({ stage: r.stage, rows: [r] });
    else if (groups.length) groups[groups.length - 1].rows.push(r);
    else groups.push({ stage: r.stage || "", rows: [r] });
  });
  return groups;
};
